import { FileDocumentRemoveIcon } from './FileDocumentRemoveIcon';

/**
 * author: Simran
 * id E5F73E5B-9876-469A-B992-EC6DA553DE1B
 * name file-document-remove
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-remove.svg
 * tags
 * - Files / Folders 
 */
export const FileTextDeleteIcon = FileDocumentRemoveIcon;
export default FileTextDeleteIcon